import {  MWhatsNewsModel, WhatsNewViewedBysModel } from "../models/MWhatsNewsModel";
import { axiosRetryConfig, customAxios } from "./AxiosHttpCommon";
import { Guid } from 'guid-typescript';

const initialFieldValues: MWhatsNewsModel = {
    WhatsNewId: Guid.EMPTY,
    WhatsNewTitle: "",
    Active: true,
    WhatsNew: ""
};

const initialFieldValuesforWhatsNewViewedBys: WhatsNewViewedBysModel = {
  WhatsNewViewedById: Guid.EMPTY,
  WhatsNewIds: [],
  WhatsNewViewedByName: ""
};
const url = 'api/MWhatsNews';

function getAll() {
  return customAxios.get(`${url}/GetAll`, axiosRetryConfig);
}

function ViewMWhatsNews(currentUserId : string) {
  return customAxios.get(`${url}/ViewMWhatsNews/${currentUserId}`, axiosRetryConfig);
}
function post(payload: MWhatsNewsModel) {
  return customAxios.post(`${url}/Add`, payload, axiosRetryConfig);
}
function AddWhatsNewViewedBys(payload: WhatsNewViewedBysModel) {
  return customAxios.post(`${url}/AddWhatsNewViewedBys`, payload, axiosRetryConfig);
}

function put(payload: MWhatsNewsModel) {
  return customAxios.put(`${url}/Edit`, payload, axiosRetryConfig);
}

function remove(id: number) {
  return customAxios.delete(`${url}/${id}`, axiosRetryConfig);
}

function getById(id: number) {
  return customAxios.get(`${url}/GetById/${id}`, axiosRetryConfig);
}

function getAllByActive() {
    return customAxios.get(`${url}/GetAllByActive`, axiosRetryConfig);
  }

  function getSoftwareFeatures(){
    return customAxios.get(`${url}/GetSoftwareFeatures`, axiosRetryConfig);
  }
export const MWhatsNewsService = {
  initialFieldValues,
  initialFieldValuesforWhatsNewViewedBys,
AddWhatsNewViewedBys,
  getAll,
  ViewMWhatsNews,
  post,
  put,
  remove,
  getById,
  getSoftwareFeatures,
  getAllByActive
};